import { ConnectorName } from '../constants';
export function getInjectedName(ethereum) {
  var _ethereum$providers;

  if (!ethereum) return ConnectorName.INJECTED; // Some injected providers detect multiple other providers and create a list at `ethers.providers`

  if ((_ethereum$providers = ethereum.providers) !== null && _ethereum$providers !== void 0 && _ethereum$providers.length) {
    // Deduplicate names using Set
    // Coinbase Wallet puts multiple providers in `ethereum.providers`
    const nameSet = new Set();
    let unknownCount = 1;

    for (const provider of ethereum.providers) {
      let name = getName(provider);

      if (!name) {
        name = `Unknown Wallet #${unknownCount}`;
        unknownCount += 1;
      }

      nameSet.add(name);
    }

    const names = [...nameSet];
    if (names.length) return names;
    return names[0] ?? ConnectorName.INJECTED;
  }

  return getName(ethereum) ?? ConnectorName.INJECTED;
}

const getName = provider => {
  if (provider.isMetaMask) return ConnectorName.METAMASK;
  if (provider.isCoinbaseWallet) return ConnectorName.COINBASE;
  return undefined;
};